import { baseApi } from "./baseApi";
import { TMatchRequest, TMatchItem, TMatchUnreadCounts } from "../../../types";

export const matchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIncoming: builder.query<TMatchRequest[], void>({
      query: () => ({ url: "/match-requests/incoming" }),
      transformResponse: (response: { data: TMatchRequest[] }) => response.data ?? response,
      providesTags: ["Match"],
    }),
    getOutgoing: builder.query<TMatchRequest[], void>({
      query: () => ({ url: "/match-requests/outgoing" }),
      transformResponse: (response: { data: TMatchRequest[] }) => response.data ?? response,
      providesTags: ["Match"],
    }),
    getMatches: builder.query<TMatchItem[], void>({
      query: () => ({ url: "/match-requests/matches" }),
      transformResponse: (response: { data: TMatchItem[] }) => response.data ?? response,
      providesTags: ["Match"],
    }),
    getMatchUnreadCounts: builder.query<TMatchUnreadCounts, void>({
      query: () => ({ url: "/match-requests/unread-counts" }),
      providesTags: [{ type: "Match", id: "COUNTS" }],
    }),
    markMatchViewed: builder.mutation<TMatchUnreadCounts, "incoming" | "matches">({
      query: (tab) => ({
        url: "/match-requests/mark-viewed",
        method: "POST",
        body: { tab },
      }),
      invalidatesTags: [{ type: "Match", id: "COUNTS" }],
    }),
    acceptRequest: builder.mutation<any, number>({
      query: (id) => ({ url: `/match-requests/${id}/accept`, method: "POST" }),
      invalidatesTags: ["Match", "Profiles", "User", "Events"],
    }),
    rejectRequest: builder.mutation<any, number>({
      query: (id) => ({ url: `/match-requests/${id}/reject`, method: "POST" }),
      invalidatesTags: ["Match", "Profiles", "User", "Events"],
    }),
    cancelRequest: builder.mutation<any, number>({
      query: (id) => ({ url: `/match-requests/${id}/cancel`, method: "POST" }),
      invalidatesTags: ["Match", "Profiles", "User", "Events"],
    }),
  }),
});

export const {
  useGetIncomingQuery,
  useGetOutgoingQuery,
  useGetMatchesQuery,
  useGetMatchUnreadCountsQuery,
  useMarkMatchViewedMutation,
  useAcceptRequestMutation,
  useRejectRequestMutation,
  useCancelRequestMutation,
} = matchApi;
